<template>
    <div class="">


        <div style="margin-top: 20px;">
            <!-- 表格 -->
            <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="id"
                        label="编号"
                        width="50"
                        align="center"
                        >
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="功能模块"
                        align="center"
                >
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="当前状态"
                        width="100"
                        align="center"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 1">开启</span>
                        <span v-if="scope.row.status === 0">关闭</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="merchantNames"
                        label="适用范围"
                        align="center">
                </el-table-column>
<!--                <el-table-column-->
<!--                        label="所属商户">-->
<!--                    <template slot-scope="scope">-->
<!--                        <div v-html="formatterMerchantNames(scope.row.merchants)"></div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column
                        prop="opUserName"
                        label="最近操作人"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="modifyTime"
                        label="最近操作时间"
                        align="center">
                </el-table-column>

                <el-table-column
                        label="操作"
                        align="center">
                    <template slot-scope="scope">
                        <el-button @click="editorModule(scope.row)" type="text" size="small">编辑适用范围</el-button>
                        <el-button @click="enableModule(scope.row.id)" type="text" size="small" v-if="scope.row.status === 0">开启</el-button>
                        <el-button @click="disableModule(scope.row.id)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                    </template>
                </el-table-column>
            </el-table>


            <!-- 分页 -->
            <el-pagination style="margin-top: 20px;"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="[10, 20, 40, 100]"
                           :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="tableTotal">
            </el-pagination>
        </div>

        <!-- 修改或新建城市经理对话框 -->
        <el-dialog title="功能模块配置" :visible.sync="isDlg" width="700px">
            <div style="margin: 20px;">
                <div>
                    <!-- {
                 code: null,
                 UserId: null,
                 contactNumber: null,
                 contactPerson: null,
                 name: null,
                 linkageId: null,
                 merchantId: null,
               } -->
                    <el-form ref="editorModuleForm" :model="editorModuleForm" label-width="120px">
                        <el-form-item label="编号">
                            <el-input clearable v-model="editorModuleForm.id" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="功能模块" prop="realName" >
                            <el-input clearable v-model="editorModuleForm.name" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="适用范围" prop="merchantIds">
                            <el-select clearable
                                       style="width:100%"
                                       v-model="editorModuleForm.merchantIds"
                                       filterable
                                       multiple
                                       remote
                                       placeholder="请输入关键词"
                                       reserve-keyword
                                       :remote-method.sync="getMerchantList"
                                       :loading="loading">
                                <el-option
                                        v-for="item in merchatOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-form>
                </div>
                <div style="text-align: center;">
                    <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
                    <el-button style="margin: 10px 20px;" @click="closeEditorUserDlg">暂不</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        components:{},
        props:{},
        data(){
            return {

                // 表格数据
                tableTotal: 0,
                tableData: [],
                pageSize: 10,
                currentPage: 1,


                // 新建编辑对话框数据

                isDlg: false,
                editorModuleForm: {
                    id: null,
                    name: null,
                    merchantIds: null
                },

                // 商户选择
                merchatOptions: [],

                // 三级区域选择
                roleOptions: [],
                loading: false,

                prentIdOptions: [],
            }
        },
        watch:{},
        computed:{},
        methods:{
            // 分页函数
            handleSizeChange(val) {
                this.pageSize = val;
                // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
                this.handleCurrentChange(1)
            },

            handleCurrentChange(val) {
                this.currentPage = val

                // 重新请求订单数据
                this.getModuleList()
            },

            // 获取模块列表
            getModuleList() {
                let self  = this;
                self.$api.getModuleList({
                    page: self.currentPage,
                    size: self.pageSize
                }).then(res => {
                    self.tableData = res.data.records || []
                    self.tableTotal = res.data.total
                })
            },

            // 添加账号
            addUser() {
                this.dlgType = 'new'
                this.editUserForm = {
                    id: null,
                    realName: null,
                    code: null,
                    merchantId: null,
                    phone: null,
                    password: null,
                    type: 1,
                    roleIds: null,
                    status: 0,
                }

                this.isDlg = true
            },

            // 修改账号
            editorModule(row) {
                let self = this;
                self.editorModuleForm = {
                    id: null,
                    name: null,
                    merchantIds: null
                };

                for(let i in self.editorModuleForm) {
                    if (i === 'merchantIds') {
                        if(row.merchantIds) {
                            let merchantIdsStr = row.merchantIds.split(",");
                            let merchantIds = [];
                            for(let i in merchantIdsStr) {
                                merchantIds.push(parseInt(merchantIdsStr[i]));
                            }
                            self.editorModuleForm.merchantIds = merchantIds;
                        }
                        console.log(self.editorModuleForm.merchantIds);
                    } else {
                        if(row[i]) {
                            self.editorModuleForm[i] = row[i];
                        }
                    }
                }
                console.log(self.editorModuleForm);
                self.isDlg = true
            },

            // 关闭编辑对话框
            closeEditorUserDlg() {
                this.isDlg = false
            },

            // 提交编辑（新建或者修改）
            submitEditor() {
                let self = this;
                this.$refs['editorModuleForm'].validate((valid) => {
                    if (valid) {
                        let params = {}
                        for(let i in self.editorModuleForm) {
                            if(i === 'merchantIds') {
                                console.log(self.editorModuleForm[i])
                                params.merchantIds = self.editorModuleForm[i].join(",")
                                console.log(params.merchantIds)
                            } else {
                                params[i] = self.editorModuleForm[i]
                            }
                        }

                        self.$api.changeModuleMerchant(params['id'] , params).then(res => {
                            if(res.code === 200) {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.getModuleList();
                                this.closeEditorUserDlg();
                            }
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

            // 请求商户列表
            getMerchantList(param) {
                let self = this;
                self.$api.getMerchantList({
                    merchantLike: param,
                    page: 1,
                    size: 100000,
                    status: 1,
                }).then(res => {
                    if(res.code === 200) {
                        self.merchatOptions = res.data.records
                    }

                })
            },

            // 请求区域
            getRoleList() {
                let self = this;
                self.$api.getRoleList({
                    page: 1,
                    size: 100000,
                }).then(res => {
                    if(res.code === 200) {
                        self.roleOptions = res.data.records
                    }

                })
            },

            enableModule(id) {
                this.$api.enableModule(id).then(res => {
                    if(res.code === 200) {
                        this.$message({
                            message: '开启成功',
                            type: 'success'
                        });
                        this.getModuleList()
                    }
                })
            },

            disableModule(id) {
                this.$api.disableModule(id).then(res => {
                    if(res.code === 200) {
                        this.$message({
                            message: '关闭成功',
                            type: 'success'
                        });
                        this.getModuleList()
                    }
                })
            },
            formatterMerchantNames(merchants) {
                let merchantNames = "";
                for(let i = 0; i < merchants.length; i++) {
                    merchantNames += merchants[i].name + ",";
                }
                return merchantNames == "" ? "" : merchantNames.substring(0, merchantNames.length - 1);
            }

        },
        created(){},
        mounted(){
            let self = this;
            self.getModuleList();


            self.getMerchantList()
            self.getRoleList()
        }
    }
</script>
<style lang="less" scoped>
</style>